"use client"

import { ChartColumnDecreasing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartColumnDecreasingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartColumnDecreasingIcon = component(Icon)({
  as: ChartColumnDecreasing,
})
